const AboutUsStep = ({
  title,
  message,
  imageLeft,
  image,
  primary_color,
  second_color,
}: {
  title: string;
  message: string;
  image: string;
  imageLeft?: boolean;
  primary_color: string;
  second_color: string;
}) => {
  return (
    <div className="h-78 lg:h-96 flex">
      {imageLeft && (
        <div className="relative mx-auto hidden md:flex">
          <img
            alt="App being used example"
            className="object-contain z-10 relative"
            src={image}
          />
          <div
            className={`${primary_color} w-64 h-32 -ml-9 bottom-10 absolute z-0`}
          />
        </div>
      )}
      <div className="max-w-lg m-auto p-10">
        <p className="text-left text-3xl font-bold mb-4">{title}</p>
        <p className="text-left text-gray-600">{message}</p>
      </div>
      {!imageLeft && (
        <div className="relative mx-auto hidden md:flex">
          <img
            alt="Mockup Iphone Template"
            className="object-contain z-10 relative"
            src={image}
          />
          <div
            className={`${primary_color} w-64 h-32 -ml-9 bottom-10 absolute z-0`}
          />
        </div>
      )}
    </div>
  );
};

export default AboutUsStep;
